
const app = {
  state: {
    menuStatus: false, // pc端时菜单初始化展示，移动端初始化时隐藏
    isClose: false,
    homename: '',
    bilingual: 'zh',
    eventId: 0,
  },
  mutations: {
    SET_EVENT_ID: (state, data) => {
      state.eventId = data
    },
    OPEN_MENU: (state, device) => {
      state.menuStatus = device

    },
    SET_IS_CLOSE: (state, isClose) => {
      state.isClose = isClose
    },
    SET_HOMENAME: (state, data) => {
      state.homename = data
    },
    SET_BILINGUAL(state, data) {
      state.bilingual = data;
    },
  },
  actions: {
    SET_BILINGUAL({ commit, state }, data) {
      commit('SET_BILINGUAL', data);
    },
    OpenMenu({ commit, state }, data) {
      commit('OPEN_MENU', data)
    },
    isCollapse({ commit, state }, data) {
      commit('SET_IS_CLOSE', !state.isClose)
    },
    setHomename({ commit, state }, data) {
      commit('SET_HOMENAME', data)
    },
    // 还差调用接口
  }
}


export default app
